import axios from 'axios';
import { ErrorEnum } from '@/types/crm-enums';
import * as jsonp from 'jsonp';

function getUrl(url, data) {
  // url = 'http://localhost:56187/' + url;
  url = crmAddress + url;
  data = data || {};
  // params
  Object.assign(data, {
    chdaccountid: localStorage.accountNum,
    chdaccountpwd: localStorage.passwordNum,
  });
  let params = '';
  for (const it in data) {
    if (true) {
      // tslint:disable-next-line:max-line-length
      params += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
    }
  }
  return url + '?' + params.replace(/&$/, '');
}

export function postForm(url, data?) {
  return new Promise<any>((resolve, reject) => {
    console.log(url);
    return jsonp(getUrl(url, data), null, (err, res) => {
      console.log(err);
      console.log(res);
      if (err) {
        reject({
          success: false,
          errid: ErrorEnum.DataError,
          msg: '服务器错误',
        } as IError);
      } else {
        if (res.success) {
          resolve(res.data as any);
        } else {
          reject({
            success: false,
            errid: res.errid,
            msg: res.msg,
          } as IError);
        }
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/CrmHttp.ts